<div [ngStyle]="{'height.px':height ? height : 30}" @fade *ngIf="loading; else content">
  <div class="loading-throbber"></div>
</div>
<ng-template #content>
  <div @fade *ngIf="loading===false">
  <ng-content></ng-content>
</div>
</ng-template>
